<template>
  <div class="modular-equation-component-container">
    <!-- DESCRIPTOR -->
    <TText
      v-if="description"
      :value="description"
      font_weight="400"
      size="10"
      :color="foreground_color"
      style="margin: 0 5px;"
    />
    <div v-else-if="!no_space" class="modular-equation-component-spacer" />

    <div class="modular-equation-component-inner-container">
      <div
        v-for="(element, index) in elements"
        :key="!element.operator && !element.select ? `element${index}` : `operator${index}`"
        :class="!element.operator && !element.select ? 'modular-equation-component-input' : ''"
        :style="`
          max-width: ${element.width + 'px'};
          ${element.button && has_any_element_label ? 'padding-top: 5px;' : ''}
          `"
      >
        <!-- INPUT FIELD -->
        <DisableableInputField
          v-if="!element.operator && !element.select && !element.button"
          :label="element.label"
          :label_suffix="element.label_suffix"
          :label_size="element.label_size"
          :icon="element.icon"
          :value="element.value"
          :width="element.width"
          :is_disabled="element.is_disabled"
          :input_type="element.input_type"
          :input_mode="element.input_mode"
          :unit="element.unit"
          :background_color="background_color"
          :foreground_color="foreground_color"
          @change="$emit(`change${element.id.replace(/\s/g, '').replace(/\./g, '')}`, $event) /* TODO: unique identifier for input field needed */"
        />

        <!-- OPERATOR -->
        <span
          v-else-if="element.operator"
          class="modular-equation-component-operator"
          :style="`
            color: ${foreground_color};
            min-width: ${element.operator.length * 10 || 10}px;
          `"
        >
          {{ element.operator }}
        </span>

        <!-- DROP DOWN -->
        <DropDownOutlinedFlat
          v-else-if="element.select"
          :label="element.label"
          :options="element.select.options"
          :value="element.value"
          :width="element.width"
          :is_disabled="element.is_disabled"
          :background_color="background_color"
          :foreground_color="foreground_color"
          @change="$emit(`change${element.id.replace(/\s/g||/\./g, '')}`, $event)"
        />
        <RadioButtonSquare
          v-else-if="element.button"
          :is_active="element.is_selected"
          :is_disabled="element.is_disabled"
          :is_invisible="element.is_invisible"
          :background_color="background_color"
          :foreground_color="foreground_color"
          :style="`
            width: 100%;
            height: ${element.height ? `${element.height}px` : '26px'};
            ${element.not_clickable ? 'cursor: default;' : ''}`"
          @setActive="$emit(`click${element.id.replace(/\s/g||/\./g, '')}`, element.value)"
        >
          <template #content>
            <!-- colors? -->
            <!-- :color="element.is_selected?background_color:foreground_color"
            :style="`color: ${element.is_selected?background_color:foreground_color}`" -->
            <TIcon
              v-if="element.icon"
              :name="element.icon"
            />
            <div
              v-else-if="element.description"
            >
              <TText :value="element.description" :color="background_color" />
            </div>
          </template>
        </RadioButtonSquare>
      </div>
    </div>
  </div>
</template>

<script>
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue'
import RadioButtonSquare from '@/components/WorkPackageWIP/RadioButtonSquare.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TText from '@/components/Taktify/TText.component.vue';

  export default {
    components: {
      DisableableInputField,
      DropDownOutlinedFlat,
      RadioButtonSquare,
      TIcon,
      TText
    },

    props: [
      'description', // is string, shown at the top of equation (string)
      'description_suffix',
      'elements', // is array of objects. can have icon, text, operator (string) and select (object with array 'options')
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'no_space', // is boolean, removes space on top
    ],

    computed:  {
      has_any_element_label() {
        if(this.elements) {
          for(let i = 0; i < this.elements.length; i++) {
            if(this.elements[i].label !== undefined) {
              return true;
            }
          }
        }
        return false;
      },
    },

    data: () => ({

    }),

    methods: {
    }
  }
</script>

<style>
  .modular-equation-component-container {
    width: 100%;
    min-width: 0;
  }
  .modular-equation-component-description {
    font-weight: 400;
    font-size: 10pt;
    margin: 0 5px;
  }
  .modular-equation-component-spacer {
    padding-bottom: 8px;
  }
  .modular-equation-component-inner-container {
     display: flex;
     flex-direction: row;
     grid-gap: 5px;
     align-items: center;
  }
  .modular-equation-component-input {
    flex-grow: 1;
    flex-basis: 0;
    min-width: 0;
    overflow: hidden;
  }
  .modular-equation-component-operator {
    font-weight: 200;
    margin: 0px -3px;
    display: flex;
    justify-content: center;
    min-width: 10px;
  }
</style>
